import { createFileRoute } from '@tanstack/react-router'
import { PublicBookingPage } from '../../../components/booking/PublicBookingPage'

export const Route = createFileRoute('/desa/$slug/booking')({
  component: () => {
    const { slug } = Route.useParams()
    return <PublicBookingPage slug={slug} />
  },
})
